import { Flex } from "@chakra-ui/layout";

export const FilterColumnSelected = () => {
  return <Flex w={35} bg="green.200" h={0.5} mt={1} ml="auto" mr="auto" />;
};
